import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import useSelection from '../../hooks/useSelection';
import useSelectionVenues from '../../hooks/useSelectionVenues';

import SelectionBlock from '../blocks/Selection';
import Menu from '../menus/Menu';
import PageMeta from '../partials/PageMeta';
import Title from '../typography/Title';

import styles from '../../../styles/pages/selection.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function SelectionPage({ page = null }) {
    const { title = null, selection: initialSelection = null } = page || {};
    const { id = null } = initialSelection || {};
    const { data: loadedSelection = null, isLoading = false } = useSelection(id);
    const { data: venues = null, isLoading: isLoadingVenues = false } = useSelectionVenues(id);
    const selection = loadedSelection || initialSelection;

    const onClickMenu = useCallback((section) => {
        const el = document !== null ? document.getElementById(section) : null;
        if (el !== null) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const menuItems = useMemo(
        () => [
            {
                label: (
                    <FormattedMessage defaultMessage="Feature films" description="Section title" />
                ),
                url: '#features',
                onClick: () => onClickMenu('features'),
            },
            {
                label: (
                    <FormattedMessage defaultMessage="Short films" description="Section title" />
                ),
                url: '#shorts',
                onClick: () => onClickMenu('shorts'),
            },
            {
                label: <FormattedMessage defaultMessage="Commission" description="Section title" />,
                url: '#comission',
                onClick: () => onClickMenu('commission'),
            },
            // {
            //     label: <FormattedMessage defaultMessage="Venues" description="Section title" />,
            //     url: '#venues',
            //     onClick: () => onClickMenu('venues'),
            // },
        ],
        [onClickMenu],
    );

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Menu
                className={styles.menu}
                itemsClassName={styles.menuItems}
                itemClassName={styles.menuItem}
                items={menuItems}
            />
            <Title className={styles.pageTitle} size="large">
                {title}
            </Title>
            <SelectionBlock
                className={styles.section}
                selection={selection}
                isLoading={isLoading}
                layout="films"
            />
            <SelectionBlock
                className={styles.section}
                selection={selection}
                isLoading={isLoading}
                layout="comitee"
            />
            <SelectionBlock venues={venues} isLoading={isLoadingVenues} layout="venues" />
        </div>
    );
}

SelectionPage.propTypes = propTypes;

export default SelectionPage;
